import React from 'react';
import { motion } from 'framer-motion';

const IMAGES = [
  { url: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379439/3_kgdzds.png', alt: 'Workplace Safety Workshop', class: 'col-span-1 row-span-1' },
  { url: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379544/7_blpgny.png', alt: 'Classroom Training', class: 'col-span-1 md:col-span-2 row-span-2' },
  { url: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379467/4_v9twk0.png', alt: 'Safety Equipment', class: 'col-span-1 row-span-1' },
  { url: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782379797/12_j3wmhy.png', alt: 'Site Walkthrough', class: 'col-span-1 row-span-1' },
  { url: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782380006/13_d58hkx.png', alt: 'Domestic Worker Practical', class: 'col-span-1 row-span-1' },
];

const Gallery = () => {
  return (
    <section className="py-24 bg-alpha-grayLight">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-alpha-green font-semibold tracking-wider uppercase mb-2 text-sm">Our Facilities & Training</h2>
          <h3 className="text-3xl md:text-4xl font-bold text-alpha-navy">Learning in Action</h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-[200px]">
          {IMAGES.map((img, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`relative overflow-hidden rounded-xl group ${img.class}`}
            >
              <img 
                src={img.url} 
                alt={img.alt} 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-alpha-navy/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <p className="text-white font-medium px-4 text-center transform translate-y-4 group-hover:translate-y-0 transition-all duration-300">
                  {img.alt}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;